export const categories = {
  musicians: {
    name: 'Musicians',
    value: 'musicians',
    image: 'https://images.unsplash.com/photo-1708689792969-9edab5fdfcaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxqYXp6JTIwc2F4b3Bob25lJTIwcGxheWVyJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3NzI2MzgwNTl8MA&ixlib=rb-4.1.0&q=85',
    subcategories: [
      { name: 'Singers', value: 'singers' },
      { name: 'Guitarists', value: 'guitarists' },
      { name: 'Drummers', value: 'drummers' },
      { name: 'Pianist', value: 'pianist' },
      { name: 'DJ', value: 'dj' },
      { name: 'Band', value: 'band' },
      { name: 'Violinist', value: 'violinist' },
      { name: 'Dhol', value: 'dhol' },
      { name: 'Others', value: 'others' }
    ]
  },
  comedians: {
    name: 'Standup Comedians',
    value: 'comedians',
    image: 'https://images.unsplash.com/photo-1641903806973-17eaf2d2634f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxzdGFuZCUyMHVwJTIwY29tZWRpYW4lMjBtaWNyb3Bob25lJTIwc3RhZ2V8ZW58MHx8fHwxNzcyNjM4MDQxfDA&ixlib=rb-4.1.0&q=85',
    subcategories: []
  },
  dancers: {
    name: 'Dancers/Choreographers',
    value: 'dancers',
    image: 'https://images.unsplash.com/photo-1761882636448-cf48b733786f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxjb250ZW1wb3JhcnklMjBkYW5jZXIlMjBqdW1waW5nJTIwc3R1ZGlvfGVufDB8fHx8MTc3MjYzODA0Mnww&ixlib=rb-4.1.0&q=85',
    subcategories: [
      { name: 'Solo Dancers', value: 'solo-dancers' },
      { name: 'Dance Groups', value: 'dance-groups' },
      { name: 'Couple Dance Choreography', value: 'couple-dance' },
      { name: 'Family Sangeet Training', value: 'sangeet-training' },
      { name: 'Dance Workshop', value: 'dance-workshop' }
    ]
  },
  magicians: {
    name: 'Magicians',
    value: 'magicians',
    image: 'https://images.unsplash.com/photo-1624543591046-a874d7d2ae30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxtYWdpY2lhbiUyMGhvbGRpbmclMjBjYXJkcyUyMHRyaWNrfGVufDB8fHx8MTc3MjYzODA0M3ww&ixlib=rb-4.1.0&q=85',
    subcategories: []
  },
  celebrities: {
    name: 'Celebrity/Influencer Appearances',
    value: 'celebrities',
    image: 'https://images.unsplash.com/photo-1681149341674-45fd772fd463?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxjb25jZXJ0JTIwc2luZ2VyJTIwc3RhZ2UlMjBsaWdodHN8ZW58MHx8fHwxNzcyNjM4MDQxfDA&ixlib=rb-4.1.0&q=85',
    subcategories: []
  },
  speakers: {
    name: 'Motivational Speakers',
    value: 'speakers',
    image: 'https://images.unsplash.com/photo-1771959454011-3f8efb8776a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxtb3RpdmF0aW9uYWwlMjBzcGVha2VyJTIwYXVkaWVuY2V8ZW58MHx8fHwxNzcyNjM4MDQ0fDA&ixlib=rb-4.1.0&q=85',
    subcategories: []
  },
  photographers: {
    name: 'Photographers',
    value: 'photographers',
    image: 'https://images.unsplash.com/photo-1747319820357-3f37244a3b27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwcGhvdG9ncmFwaGVyJTIwaG9sZGluZyUyMGNhbWVyYXxlbnwwfHx8fDE3NzI2MzgwNDR8MA&ixlib=rb-4.1.0&q=85',
    subcategories: []
  },
  videographers: {
    name: 'Videographers',
    value: 'videographers',
    image: 'https://images.unsplash.com/photo-1575845264176-15b3de2b62f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHx2aWRlb2dyYXBoZXIlMjB3aXRoJTIwZ2ltYmFsJTIwY2FtZXJhfGVufDB8fHx8MTc3MjYzODA2Mnww&ixlib=rb-4.1.0&q=85',
    subcategories: []
  }
};

export const getAllCategories = () => Object.values(categories);
export const getCategoryByValue = (value) => categories[value];
